import VuexPersistence from 'vuex-persist'
import localForage from 'localforage'

export default function vuexPersistence(reducer = null) {
	return new VuexPersistence({
		storage: localForage,
		asyncStorage: true,
		reducer
	})
}


// WEBPACK FOOTER //
// ./src/plugins/vuex-persistence.js